const ServiceGuide = (props) => {
  return (
    <div className="border-bottom py-5 serviceAnBox">
      <div className="col-12 p-0 mt-5 mb-3 font-weight-bold chRyangTitle">
        서비스 안내
      </div>
      <p>
        1.ABYS 토탈멀티서비스는 자동차와 건물의 크리닝과 윈도우필름을 통한
        에너지 세이빙, 외관의 유지관리를 컨설팅 및 서비스 진행, 사후관리를
        진행하는 토탈 관리 서비스입니다.
      </p>
      <p>
        2.ABYS 서비스는 ICT (Information & Communication Technology)기술을
        도입한 서비스 관리 프로그램입니다.
      </p>
      <p>
        3.우리나라 환경에 맞춘 서비스 SOP (Standard Operation Precedure -
        표준작업절차)를 개발하여 전국 동일 서비스 품질을 공급합니다.
      </p>
      <p>
        4.ABYS 서비스는 서비스에 사용되는 재료가 브랜드가 상이하므로 A/S가
        발생시 시공하신 대리점에서만 서비스가 가능합니다
      </p>
      <p className="abysMemberTextTitle">ABYS MEMBERS</p>
      <div className="row p-0">
        <div className="col-4 pl-0">
          <img className="w-100" src='/img/members.png' />
        </div>
        <div className="col-8 pr-0">
          전국 ABYS매장에서 시공하신 서비스는 ABYS 본사의 서비스품질 기준 관리와
          서비스 이력 관리를 제공받으실 수 있습니다.<br></br>(ABYS HOT-LINE:
          1544-2160)
        </div>
      </div>
    </div>
  );
};

export default ServiceGuide;
